module.exports = __webpack_public_path__ + "static/media/5.7feee31d.svg";